const oneOf = (arr, obj) => {
  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i] in obj) {
      return obj[arr[i]];
    }
  }
  return '';
};

export default oneOf;
